import { render, staticRenderFns } from "./DestroyModuleInventory.vue?vue&type=template&id=5fb4afa8&"
import script from "./DestroyModuleInventory.vue?vue&type=script&lang=js&"
export * from "./DestroyModuleInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports